import { Component, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';

@Component({
  selector: 'app-avatar-element',
  standalone: true,
  imports: [AvatarGroupModule, AvatarModule],
  templateUrl: './avatar-element.component.html',
  styleUrl: './avatar-element.component.css',
})
export class AvatarElementComponent {
  @Input({ required: true }) size!: any;
  @Input({ required: true }) shape!: any;
  @Input({ required: true }) image!: string;
}
